import articlePlaceholder from "@/assets/article-placeholder.jpg";

/** Placeholder som används när artikelbilden saknas eller är en död länk. */
export const ARTICLE_PLACEHOLDER_IMAGE = articlePlaceholder;

/**
 * Mediabiblioteket från gamla WordPress-sajten är kopierat till vår egen
 * lagring (bucket `legacy-media`), så uploads-bilder pekas om dit.
 * /Images-sökvägarna finns inte kvar någonstans.
 */
export const LEGACY_MEDIA_BASE = `${
  import.meta.env["VITE_SUPABASE_URL"] ?? ""
}/storage/v1/object/public/legacy-media`;

/** Matchar gamla uploads-URL:er, både på elmarknad.se och staging-domänen. */
export const LEGACY_UPLOADS_PATTERN =
  /https?:\/\/(?:www\.)?(?:elmarknad\.se|gretna\.templweb\.com)\/wp-content\/uploads/gi;

const DEAD_IMAGE_PATTERNS = [/elmarknad\.se\/Images\//i];

/** Pekar om gamla uploads-URL:er till vår egen lagring. */
export const rewriteLegacyImageUrl = (src: string): string =>
  src.replace(LEGACY_UPLOADS_PATTERN, LEGACY_MEDIA_BASE);


export const isUsableArticleImage = (src?: string | null): src is string =>
  Boolean(src && src.trim() && !DEAD_IMAGE_PATTERNS.some((re) => re.test(src)));

/** Returnerar en visningsbar bild – artikelbilden eller placeholdern. */
export const articleImageSrc = (src?: string | null): string =>
  isUsableArticleImage(src) ? rewriteLegacyImageUrl(src) : ARTICLE_PLACEHOLDER_IMAGE;


/** Byter en trasig bild till placeholdern (med loop-skydd). */
const swapToPlaceholder = (img: HTMLImageElement) => {
  if (img.dataset["fallbackApplied"] === "true") return;
  if (img.src.endsWith(ARTICLE_PLACEHOLDER_IMAGE)) return;
  img.dataset["fallbackApplied"] = "true";
  img.src = ARTICLE_PLACEHOLDER_IMAGE;
};

/** onError-hanterare som byter till placeholdern om bilden inte kan laddas. */
export const handleArticleImageError = (
  event: React.SyntheticEvent<HTMLImageElement>,
) => {
  swapToPlaceholder(event.currentTarget);
};

let globalFallbackInstalled = false;

/**
 * Global fallback: fångar error-events (som inte bubblar, därför capture-fasen)
 * från ALLA <img>-element och byter trasiga bilder mot placeholder-bilden
 * istället för att visa webbläsarens trasiga-bild-ikon. Anropas en gång från root.
 */
export const installGlobalImageFallback = () => {
  if (globalFallbackInstalled || typeof document === "undefined") return;
  globalFallbackInstalled = true;
  document.addEventListener(
    "error",
    (event) => {
      const target = event.target;
      if (target instanceof HTMLImageElement) swapToPlaceholder(target);
    },
    true,
  );
};
